import { useEffect } from 'react';
import { Divider } from '@treezor/design-system';

import { useAppSelector, useAppDispatch } from '@/hooks/redux-helpers';

import { getOnboardingUrl } from '@/store/actions/integration-config.action';
import { getPasswordStrategy } from '@/store/actions/password-config.action';

import { ConfigPassword } from '@/pages/admin/configuration/ConfigPassword';
import { ConfigOnboarding } from '@/pages/admin/configuration/ConfigOnboarding';
import { ConfigCommonSkeleton } from '@/pages/admin/configuration/ConfigCommonSkeleton';

export const Integration = () => {
  const dispatch = useAppDispatch();

  const onboardingUrlConfig = useAppSelector((state) => state.integrationConfig.onboardingUrl);
  const isOnboardingUrlConfigLoading = useAppSelector((state) => state.integrationConfig.isLoading);

  const passwordStrategy = useAppSelector((state) => state.passwordStrategy.passwordStrategy);
  const isPasswordStrategyLoading = useAppSelector((state) => state.passwordStrategy.isLoading);

  useEffect(() => {
    dispatch(getOnboardingUrl());
    dispatch(getPasswordStrategy());
  }, [dispatch]);

  return (
    <div className="pt-5">
      <div className="w-auto border bg-primary border-primary rounded-100 py-9 px-8 mt-5 mb-3 mx-3 h-fit relative">
        {isPasswordStrategyLoading ? (
          <ConfigCommonSkeleton />
        ) : (
          <ConfigPassword passwordChangeRedirectUrl={passwordStrategy.passwordChangeRedirectUrl} />
        )}

        <Divider thickness="200" className="my-8" />

        {isOnboardingUrlConfigLoading ? (
          <ConfigCommonSkeleton />
        ) : (
          <ConfigOnboarding onboardingUrlConfig={onboardingUrlConfig} />
        )}
      </div>
    </div>
  );
};
